import React, { useState, useMemo, useEffect } from "react";
import "../../Styles/PC/BookConsultationModal.css";
import { toast } from "react-toastify";
import { getAvailableTimeSlotsAPI, bookAppointmentAPI } from "../../services/pcConfigService";
import { X, Calendar, Clock, User, Video, MapPin } from 'lucide-react';

const BookConsultationModal = ({
    phaseData,
    patientId,
    patientInfo,
    doctorsList,
    clinicRegNo,
    nextAptOrder,
    isReviewAppointment,
    onClose,
}) => {
    const [selectedDoctor, setSelectedDoctor] = useState("");
    const [consultDate, setConsultDate] = useState("");
    const [consultTime, setConsultTime] = useState("");
    const [timeSlots, setTimeSlots] = useState([]);
    const [fetchedTimeslots, setFetchedTimeslots] = useState([]);
    const [consultationType, setConsultationType] = useState("WALKIN");
    const [specialityType, setSpecialityType] = useState('');
    const [filteredDoctors, setfilteredDoctors] = useState([]);

    console.log('BookConsultationModal', phaseData, patientInfo, doctorsList);
    console.log('BookConsultationModal', nextAptOrder, isReviewAppointment);

    // Filter doctors based on consultation completion status




    useEffect(() => {
        if (consultDate && selectedDoctor) {
            fetchTimeSlots();
        }
        if (!doctorsList || doctorsList.length === 0) return [];

        if (!isReviewAppointment) {
            if (nextAptOrder == 0) {
                if (phaseData?.screeningSessions?.length > 0) {
                    // debugger
                    let specialityApt;
                    let specialistSpeciality;
                    specialityApt = phaseData?.screeningSessions.filter((s) => s.order === nextAptOrder)[0];
                    setSpecialityType(specialityApt?.type);
                    if (specialityApt.type == 'specialist') {
                        specialistSpeciality = specialityApt.specialtyName;
                    }
                    if (specialityApt?.type == 'dietician') {
                        setfilteredDoctors(doctorsList?.filter(
                            (doc) => doc.specialization?.toLowerCase().includes("diet") ||
                                doc.specialization?.toLowerCase().includes("dietician") ||
                                doc.specialization?.toLowerCase().includes("nutrition")
                        ) || []);
                    }
                    if (specialityApt?.type == 'fitness') {
                        setfilteredDoctors(doctorsList?.filter(
                            (doc) => doc.specialization?.toLowerCase().includes("fitness") ||
                                doc.specialization?.toLowerCase().includes("physiology") ||
                                doc.specialization?.toLowerCase().includes("exercise")
                        ) || []);
                    }
                    if (specialityApt?.type == 'specialist' && specialistSpeciality) {
                        setfilteredDoctors(doctorsList?.filter(
                            (doc) => doc.specialization?.toLowerCase() == specialistSpeciality.toLowerCase()
                        ) || [])
                    }

                } else {
                    setSpecialityType("gp");
                    setfilteredDoctors(doctorsList?.filter(
                        (doc) => doc.specialization?.toLowerCase() === "general practitioner" ||
                            doc.specialization?.toLowerCase() === "gp" ||
                            doc.specialization?.includes("general")
                    ) || []);
                }

            }
            else {
                let specialityApt;
                let specialistSpeciality;
                if (phaseData?.screeningSessions?.length > 0) {
                    // debugger;
                    specialityApt = phaseData?.screeningSessions.filter((s) => s.order === nextAptOrder)[0];
                    setSpecialityType(specialityApt?.type);
                    if (specialityApt.type == 'specialist') {
                        specialistSpeciality = specialityApt.specialtyName;
                    }
                    if (specialityApt?.type == 'dietician') {
                        setfilteredDoctors(doctorsList?.filter(
                            (doc) => doc.specialization?.toLowerCase().includes("diet") ||
                                doc.specialization?.toLowerCase().includes("dietician") ||
                                doc.specialization?.toLowerCase().includes("nutrition")
                        ) || []);
                    }
                    if (specialityApt?.type == 'fitness') {
                        setfilteredDoctors(doctorsList?.filter(
                            (doc) => doc.specialization?.toLowerCase().includes("fitness") ||
                                doc.specialization?.toLowerCase().includes("physiology") ||
                                doc.specialization?.toLowerCase().includes("exercise")
                        ) || []);
                    }
                    if (specialityApt?.type == 'specialist' && specialistSpeciality) {
                        setfilteredDoctors(doctorsList?.filter(
                            (doc) => doc.specialization?.toLowerCase() == specialistSpeciality.toLowerCase()
                        ) || [])
                    }
                }
            }
        }
        else {
            setSpecialityType("gp");
            setfilteredDoctors(doctorsList?.filter(
                (doc) => doc.specialization?.toLowerCase() === "general practitioner" ||
                    doc.specialization?.toLowerCase() === "gp" ||
                    doc.specialization?.includes("general")
            ) || []);
        }
    }, [consultDate, selectedDoctor, nextAptOrder, doctorsList, phaseData]);

    const fetchTimeSlots = async () => {
        try {
            const response = await getAvailableTimeSlotsAPI(selectedDoctor, consultDate, clinicRegNo);
            console.log('time slots response', JSON.stringify(response));
            if (response) {
                if (!response?.available?.length) {
                    setTimeSlots([]);
                    return;
                }
                setFetchedTimeslots(response?.available)
                const now = new Date();
                const selectedDate = new Date(response?.date);

                const filteredSlots = response?.available
                    .filter((slot) => {
                        const slotStart = slot[0];

                        // Remove if booked
                        const isBooked = response?.booked.some(
                            (bookedSlot) => bookedSlot[0] === slotStart
                        );

                        if (isBooked) return false;

                        // Create Date object for slot time
                        const slotDateTime = new Date(selectedDate);
                        const [hours, minutes] = slotStart.split(":").map(Number);
                        slotDateTime.setHours(hours, minutes, 0, 0);

                        // If selected date is today → remove past slots
                        const isToday =
                            selectedDate.toDateString() === now.toDateString();

                        if (isToday && slotDateTime <= now) {
                            return false;
                        }

                        return true;
                    })
                    .sort((a, b) => {
                        const [hA, mA] = a[0].split(":").map(Number);
                        const [hB, mB] = b[0].split(":").map(Number);

                        if (hA === hB) return mA - mB;
                        return hA - hB;
                    })
                    .map((slot) => slot[0]); // Keep only start time

                setTimeSlots(filteredSlots);
            }
        } catch (err) {
            console.error("Error fetching time slots:", err);
        }
    };
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split("T")[0];
    };

    const handleBookConsultation = async () => {
        if (!selectedDoctor || !consultDate || !consultTime) {
            toast.error("Please fill all fields");
            return;
        }

        const slotend = fetchedTimeslots.filter(t => t[0] == consultTime)[0] || [
            consultTime,
            consultTime,
        ];
        const payload = {
            patientID: patientId,
            providerID: selectedDoctor,
            clinicID: '',
            clinicRegNo: clinicRegNo,
            date: consultDate,
            slot_starts: consultTime,
            slot_ends: slotend[1],
            appointmentType: consultationType,
            appointmentFor: 'self',
            briefExplanation: '',
            consultationKey: specialityType,
            currentPhase: phaseData.phaseNumber,
            order: nextAptOrder,
            isReviewAppointment: isReviewAppointment,
        };

        console.log("Consultation Booking Payload:", payload);

        // return;
        const bookAptRes = await bookAppointmentAPI(payload);
        console.log('bookAptRes', bookAptRes)
        if (bookAptRes?.success) {
            toast.success("Consultation booked successfully");
            onClose();
        } else {
            toast.error(bookAptRes?.errors);
        }
    };

    return (
        <div className="bcm-overlay">
            <div className="bcm-modal">
                {/* Header */}
                <div className="bcm-header">
                    <div>
                        <h3>Book Consultation</h3>
                        <p>
                            Schedule a consultation for{" "}
                            <strong>
                                {patientInfo?.firstName} {patientInfo?.lastName}
                            </strong>
                        </p>
                    </div>
                    <button className="bcm-close" onClick={onClose}>
                        <X size={24} />
                    </button>
                </div>

                {/* Body */}
                <div className="bcm-body">
                    {/* Doctor */}
                    <div className="bcm-field">
                        <label>Select Doctor</label>
                        <div className="bcm-input-wrapper">
                            {/* <User size={18} className="bcm-input-icon" /> */}
                            <select
                                value={selectedDoctor}
                                onChange={(e) =>
                                    setSelectedDoctor(e.target.value)
                                }
                            >
                                <option value="">Select doctor</option>
                                {filteredDoctors.map((doc) => (
                                    <option key={doc._id} value={doc.providerID}>
                                        {doc.fullName} - {doc.specialization}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Date */}
                    <div className="bcm-field">
                        <label>Consultation Date</label>
                        <div className="bcm-input-wrapper">
                            {/* <Calendar size={18} className="bcm-input-icon" /> */}
                            <input
                                type="date"
                                min={getTodayDate()}
                                value={consultDate}
                                onChange={(e) => {
                                    setConsultDate(e.target.value);
                                    setConsultTime("");
                                }}
                            />
                        </div>
                    </div>

                    {/* Time Slot */}
                    <div className="bcm-field">
                        <label>Time Slot</label>
                        <div className="bcm-input-wrapper">
                            {/* <Clock size={18} className="bcm-input-icon" /> */}
                            <select
                                disabled={!consultDate}
                                value={consultTime}
                                onChange={(e) =>
                                    setConsultTime(e.target.value)
                                }
                            >
                                <option value="">Select time</option>
                                {timeSlots.map((slot, index) => (
                                    <option key={index} value={slot}>
                                        {slot}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Appointment Type */}
                    <div className="bcm-field">
                        <label>Appointment Type</label>
                        <div className="bcm-input-wrapper">
                            {/* {consultationType === 'WALKIN' ? <MapPin size={18} className="bcm-input-icon" /> : <Video size={18} className="bcm-input-icon" />} */}
                            <select
                                value={consultationType}
                                onChange={(e) =>
                                    setConsultationType(e.target.value)
                                }
                            >
                                <option value="WALKIN">InClinic</option>
                                <option value="VIDEO">Online</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="bcm-footer">
                    <button className="bcm-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="bcm-book"
                        onClick={handleBookConsultation}
                    >
                        Book Consultation
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BookConsultationModal;
